import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { VideoBoxWithText } from '../../templates';
import './styles.css';

/**
 * The QrVideoView section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class QrVideoView extends Component {

	render () {
		const {
			heading,
			videoId,
			image,
		} = this.props.content.qrLandingPage.qrVideo;

		return (
			<VideoBoxWithText
				heading={heading}
				videoId={videoId}
				image={image}
				className='QrVideoView'
			/>
		);
	}

}

export default withLanguageContext(QrVideoView);



// WEBPACK FOOTER //
// ./src/components/views/QrVideoView/QrVideoView.js